const moment = require('moment')

const { default: cookie } = require("react-cookies")

export const getTenant = () => {
  const tenent = cookie.load("TENANT")
  return tenent;
};

export const getUserData = () => {
  return cookie.load("GST_USER_DATA") || "";
};

export const getUserName = () => {
  if (cookie.load("GST_USER_DATA")) {
    const userData = cookie.load("GST_USER_DATA")
    return userData.userName || "";
  }
};

export const getUserId = () => {
  if (cookie.load("GST_USER_DATA")) {
    const userData = cookie.load("GST_USER_DATA")
    return userData.userId || "";
  }
};

export const getUserEmail = () => {
  if (cookie.load("GST_USER_DATA")) {
    const userData = cookie.load("GST_USER_DATA")
    return userData.userEmail || "";
  }
};

export const getUserAuthType = () => {
  if (cookie.load("GST_USER_DATA")) {
    const userData = cookie.load("GST_USER_DATA")
    return userData.auth_type || "";
  }
};

export const getCurrentFinancialYear = () => {
  var fiscalyear = "";
  var today = new Date();
  if ((today.getMonth() + 1) <= 3) {
    fiscalyear = (today.getFullYear() - 1) + "-" + today.getFullYear()
  } else {
    fiscalyear = today.getFullYear() + "-" + (today.getFullYear() + 1)
  }
  let arr = fiscalyear.split("-")
  return arr
}

export const customDateFilter = (value, filter) => {
  if (filter !== null) {
    let endDate = new Date(filter.getFullYear(), filter.getMonth() + 1, 0)
    return (moment(value).isSameOrAfter(filter) && moment(value).isSameOrBefore(endDate))
  } else {
    return value;
  }
}